module.exports = __webpack_public_path__ + "ce09ceffca566012ede9f3ceb391f4c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-index-img3.jpg
// module id = 228
// module chunks = 3